exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n/* Temporary override until we have\n   * widths available in GlDisclosureDropdown\n   * https://gitlab.com/gitlab-org/gitlab-ui/-/issues/2501\n   */\n.code-dropdown .gl-new-dropdown-panel {\n  width: 100%;\n  max-width: 348px;\n}\n", ""]);

